

export enum PersonRole {
    NONE = 'NONE',
    ORGANIZER = 'ORGANIZER',
    COMPETITOR = 'COMPETITOR',
    JUDGE = 'JUDGE',
    JUMP_ADMIN = 'JUMP_ADMIN',
    REVIEWER = 'REVIEWER'

}

export type Person = {
    id: string;
    email: string;              // person with role in competition or jump
    replyTo?: string;
    cc?: string;
    invite?: number;
    invited?: number;
    retries?: number;
    role: PersonRole;
    name?: string;
    picture?: string;
    // "magicId" identifies invitation for invited guest user. 
    // user with matching magicId in landing URL with matching email can interact 
    // as a reviewer, voter or other guest role.
    magicId?: string;         
    competitionId?: string;
    jumpId?: string;
    verified?: boolean;
    boostAllocation?: string;
    url?: string;
    created: string;
}
